// Importações do framework
import React from "react";
import { Link, useHistory } from "react-router-dom";

// Ícones
import { BsFillCaretDownFill } from "react-icons/bs";

// Estilização
import "./style.css";

// Logos
import logo from "../../assets/logo-vermelha.svg";
import tipo from "../../assets/tipo-branca.svg"

export default function Inicio() {
    // Define a navegação
    const nav = useHistory();

    // Navegação para a tela de home
    function home() {
        nav.push("/home");
    }

    return (
        <div className="slide">
            <img src={logo} className="imagem" />

            <div className="log" onClick={home}>
                <span className="entrar">Entrar</span>
                <BsFillCaretDownFill size={40} />
            </div>

            <footer>
                <img src={tipo} className="tipo" />
            </footer>
        </div>
    );
}